"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserCredentials_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var UserCredentialType_1 = require("./UserCredentialType");
var UserCredentials_Factory = /** @class */ (function () {
    function UserCredentials_Factory() {
    }
    UserCredentials_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            CredentialTypeCode: model.CredentialTypeCode,
            Password: model.Password,
            RecordCreated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
            UserCredentialType: UserCredentialType_1.UserCredentialType_Factory.CreateIncoming(model.UserCredentialType),
            UserId: model.UserId,
            Username: model.Username,
        };
        return result;
    };
    UserCredentials_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            CredentialTypeCode: model.CredentialTypeCode,
            Password: model.Password,
            RecordCreated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
            UserCredentialType: UserCredentialType_1.UserCredentialType_Factory.CreateOutgoing(model.UserCredentialType),
            UserId: model.UserId,
            Username: model.Username,
        };
        return result;
    };
    return UserCredentials_Factory;
}());
exports.UserCredentials_Factory = UserCredentials_Factory;
